import { useParams } from "react-router-dom";
import ViewTasks from "@swivu/shared-ui/src/components/ViewTasks.js";
const ViewTasksPublic = () => {
  const { id, slug } = useParams<{ id: string; slug: string }>();
  return (
    <ViewTasks.Provider
      api="public"
      id={id!}
      slug={slug!}
      baseUrl={`/p/${slug}/tasks/${id}/task/`}
    >
      <div className="py-4">
        <ViewTasks />
      </div>
    </ViewTasks.Provider>
  );
};

export default ViewTasksPublic;
